/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Step2Inputs */

const en_dr_room_step2 = /** @type {(inputs: Dr_Room_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users`)
};

const id_dr_room_step2 = /** @type {(inputs: Dr_Room_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengguna`)
};

/**
* | output |
* | --- |
* | "Users" |
*
* @param {Dr_Room_Step2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_step2 = /** @type {((inputs?: Dr_Room_Step2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Step2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_step2(inputs)
	return en_dr_room_step2(inputs)
});